import React from 'react';
import './../styles/RegistrationPage.css';
import '../styles/components/Button.css';
import TextInput from '../components/inputs/TextInput';
import Dropdown from '../components/inputs/Dropdown';
import { getDropdownData, getUserInfo, submitRegistrationData } from "../api/registration/UserRegistrationAPI";
import { useEffect, useState } from "react";
import Page from '../components/Page';
import ErrorPage from "../pages/ErrorPage"
import useSetOtherSelected from '../hooks/useSetOtherSelected';
import { TOTAL_GRAD_YEARS_VISIBLE } from '../constants';
import CheckboxGroup from '../components/inputs/CheckboxGroup';
import PhoneInput from '../components/inputs/PhoneInput';
import EmailInput from '../components/inputs/EmailInput';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';

/**
 * Text field for "Other" dropdown options
 * Prop definitions and usage are the same as the <TextInput> component.
 */
const OtherTextField = ({ id, placeholder, value, setValue, required }) => {
  return (
    <TextInput
		id={id}
		placeholder={placeholder}
		label=' '
		charLimit={80}
		value={value}
		setValue={setValue}
		required={required}
		isOther={true}
    />
  );
};

// TODO: get roles from backend and block this route access, don't just block the access from backend endpoints
const RegistrationPage = () => {
	const [formSubmitDisabled, setFormSubmitDisabled] = useState(false);
	const navigate = useNavigate();
	const [apiSuccess, setApiSuccess] = useState(true);
	const [loading, setLoading] = useState(true);
	const [user, setUser] = useState(null);
	const [dropdownData, setDropdownData] = useState({
		genders: [],
		majors: [],
		degrees: [],
		pronouns: [],
		races: [],
		shirtSizes: [],
	});

	useEffect(() => {
		(async () => {
			try {
				setLoading(true);
				const data = await getDropdownData();
				const info = await getUserInfo();
				setDropdownData(data);
				setUser(info);
			} catch(error) {
				setApiSuccess(false);
			} finally {
				setLoading(false);
			}
			
			})();
	}, []);

	const { genders, majors, degrees, pronouns, races, shirtSizes } = dropdownData;

	const [selectedGenderID, setSelectedGenderID] = useState(null);
	const [selectedRaceID, setSelectedRaceID] = useState(null);
	const [selectedMajorID, setSelectedMajorID] = useState(null);
	const [selectedDegreeID, setSelectedDegreeID] = useState(null);
	const [selectedShirtSizeID, setSelectedShirtSizeID] = useState(null);

	const [otherGenderSelected] = useSetOtherSelected(genders, selectedGenderID, "dropdownValue");
	const [otherRaceSelected] = useSetOtherSelected(races, selectedRaceID, "dropdownValue");
	const [otherMajorSelected] = useSetOtherSelected(majors, selectedMajorID, "dropdownValue");
	const [otherShirtSizeSelected] = useSetOtherSelected(shirtSizes, selectedShirtSizeID, "dropdownValue");

	// const [selectedGradDate, setSelectedGradDate] = useState(null);
	const currentYear = new Date().getFullYear();
	const gradDateOptions = [];
	for (let i = 0; i <= TOTAL_GRAD_YEARS_VISIBLE; i++) {
		gradDateOptions.push({
			value: currentYear + i,
			label: String(currentYear + i),
		});
	}

	const [selectedPronounIDs, setSelectedPronounIDs] = useState([]);
	const [pronounCheckboxesDisabled, setPronounCheckboxesDisabled] = useState(false);
	const [otherPronouns, setOtherPronouns] = useState('');

	// Event handler for selecting pronouns
	const handlePronounSelect = (event) => {
		const changedValue = event.target.value;
		const isChecked = event.target.checked;
		// Add/remove changed checkbox from selected array
		if (isChecked) {
			setSelectedPronounIDs([...selectedPronounIDs, Number(changedValue)]);
		} else {
			setSelectedPronounIDs(selectedPronounIDs.filter((id) => Number(id) !== Number(changedValue)));
		}
	};

	// TODO: add checkSession when complete
	useEffect(() => {
		if (otherPronouns !== '') {
			setPronounCheckboxesDisabled(true);
		} else {
			setPronounCheckboxesDisabled(false);
		}
	}, [otherPronouns]);

	if (loading) {
		<Page>
			<div>Loading...</div>
		</Page>
	}

	const validateForm = async (event) => {
		// Prevent default form submission behavior
		event.preventDefault();

		// Disable submit button after it is clicked.
		// If we leave the button enabled, a user could spam-click and send 
		// multiple API requests to register the same account.
		setFormSubmitDisabled(true);

		// Access form data
		const formData = new FormData(event.target);

		// Convert form data into a JSON format
		const formDataJSON = {};
		for (const entry of formData) {
			if (entry[0] === 'pronouns-group') {
				// Insert the array of selected pronoun IDs instead of the default checkbox data
				// If a custom pronoun is specified, these checboxes are disabled and won't be included in the form data
				formDataJSON['selectedPronounIDs'] = selectedPronounIDs;
			} 
			// Validate email address and phone number with a regex

			else if (!isNaN(entry[1]) && entry[1] !== '') {
				// If the entry is a number (ID), convert it from a string to a number
				formDataJSON[entry[0]] = Number(entry[1]);
			}
			else {
				// Add all other entries to the JSON as is
				formDataJSON[entry[0]] = entry[1].trim();
			}
		}

		try {
            toast.loading("Registering...");
            setTimeout(async () => {
                const response = await submitRegistrationData(formDataJSON);
                if (response.success) {
                    toast.dismiss();
                    try {
                        toast.success(response.message);
						setTimeout(async () => {
							navigate("/member/dashboard");
						}, 300);
                    } catch (jsonError) {
                        console.error("Error parsing JSON:", jsonError);
                        toast.error("Error parsing server response.");
                    }
                } else {
                    toast.dismiss();
                    console.log("Error creating Member. Status:", response.status);
                    toast.error("Registration failed to update. Status: " + response.status);
                }
            }, 500);
        } catch (error) {
            toast.dismiss();
            console.error("Error submitting changes:", error);
            toast.error("Something went wrong. Please check your connection and try again.");
        }
		// Re-enable submit button after API response comes back
		setFormSubmitDisabled(false);



	}

	return (
		<>
		{!apiSuccess && <ErrorPage />}
		{apiSuccess && (
			<Page>
				<div className="signup-page">
					<div className="signup-form-container">
						<h2 className="signup-subheader">{"Welcome " + user?.firstName + "!"}</h2>
						<p>Please provide the following information to create your profile.</p>
						<p>All fields marked with * are required.</p>
						<form name='registration-form' id='registration-form' onSubmit={(event) => validateForm(event)}>
							{/* <div className="form-field">
								<TextInput id="ritUserID" placeholder="RIT User ID (ex. xyz1234)" className="form-input" charLimit={7} label='RIT User ID' required />
							</div>
							<div className="form-field">
								<TextInput id="firstName" placeholder="First Name" className="form-input" charLimit={80} label='First Name' required />
							</div>
							<div className="form-field">
								<TextInput id="lastName" placeholder="Last Name" className="form-input" charLimit={80} label='Last Name' required />
							</div> */}
							<div className="form-field">
								<TextInput id="preferredName" placeholder="Preferred Name" className="form-input" charLimit={80} label='Preferred Name'/>
							</div>
							<div className="form-field">
								<EmailInput id="personalEmail" placeholder="Personal Email" type="email" className="form-input" charLimit={80} label='Personal Email' />
							</div>
							<div className="form-field">
								<PhoneInput id='phoneNumber' placeholder='Phone Number' label='Phone Number' className="form-input" />
							</div>
							<div className="form-field">
								<label className='input-label' htmlFor="pronouns">Pronouns</label>
								<p className='note-text'>Note: Pronouns specified in the "Other" field will override any checkbox selections.</p>
								<CheckboxGroup
									id="pronouns"
									name="pronouns-group"
									options={
										pronouns.map((p) => {
											return {
												value: p.id,
												label: p.dropdownValue,
											}
										})
									}
									onChange={handlePronounSelect}
									groupDisabled={pronounCheckboxesDisabled}
								/>
								<OtherTextField id="otherPronoun" placeholder="Other" value={otherPronouns} setValue={(event) => setOtherPronouns(event.target.value)} />
							</div>
							<div className="form-field">
								<Dropdown
									id="gender"
									name="genderID"
									options={
										genders.map((g) => {
											return {
												value: g.id,
												label: g.dropdownValue,
											};
										})
									}
									onChange={(event) => setSelectedGenderID(event.target.value)}
									className="form-input"
									label='Gender'
									required
								/>
								{otherGenderSelected && <OtherTextField id="otherGender" placeholder="Gender" required />}
							</div>
							<div className="form-field">
								<Dropdown
									id="race"
									name="raceID"
									options={
										races.map((r) => {
											return {
												value: r.id,
												label: r.dropdownValue,
											};
										})
									}
									onChange={(event) => setSelectedRaceID(event.target.value)}
									className="form-input"
									label='Race'
									required
								/>
								{otherRaceSelected && <OtherTextField id="otherRace" placeholder="Race" required />}
							</div>
							<div className="form-field">
								<Dropdown
									id="major"
									name="majorID"
									options={
										majors.map((m) => {
											return {
												value: m.id,
												label: m.dropdownValue,
											};
										})
									}
									onChange={(event) => setSelectedMajorID(event.target.value)}
									className="form-input"
									label='Major'
									required
								/>
								{otherMajorSelected && <OtherTextField id="otherMajor" placeholder="Major" required />}
							</div>
							<div className="form-field">
								<Dropdown
									id="degree"
									name="degreeID"
									options={
									degrees.map((d) => {
										return {
											value: d.id,
											label: d.dropdownValue,
										}
									})
									}
									onChange={(event) => setSelectedDegreeID(event.target.value)}
									className="form-input"
									label='Degree Program'
									required
								/>
							</div>
							<div className='form-field'>
								<Dropdown
									id="grad-year"
									name="gradYear"
									options={gradDateOptions}
									className="form-input"
									label='Expected Graduation Date'
									required
								/>
							</div>
							<div className="form-field">
								<Dropdown
									id="tshirt"
									name="shirtSizeID"
									options={
									shirtSizes.map((s) => {
										return {
											value: s.id,
											label: s.dropdownValue,
										}
									})
									}
									onChange={(event) => setSelectedShirtSizeID(event.target.value)}
									className="form-input"
									label='T-Shirt Size'
									required
								/>
								{otherShirtSizeSelected && <OtherTextField id="otherShirtSize" placeholder="Shirt Size" required />}
							</div>
							<input
								type='submit'
								className='button primary-btn'
								value="Submit"
								disabled={formSubmitDisabled}
							/>
						</form>
					</div>
				</div>
			</Page>
		)}
		</>
	);
}

export default RegistrationPage;
